import { generateSetChild } from '@/helpers/VuexHelpers'
import { service } from '@/service/index'
import { dayjs, dayjsLocal } from "@/helpers/dayjs"
import CheckoutTimeUtil from '@/helpers/CheckoutTimeUtil'
import { config } from '@/config'

window.dayjs = dayjs
//helper instance
let timeUtil = new CheckoutTimeUtil()

export default {
	namespaced: true,
	state: {
		checkoutToken: "",
		serverData: "",
		shippings: null,
		payments: [],
		billingAddress: {},
		shippingAddress: {},
		orderDate: null,
		transaction: null,
		savedPayments: [],
	},
	actions: {
		async summary({commit, state, dispatch, rootState}, {token = null, accumulatorGroup = null} = {}) {
			await dispatch('cart/restoreCart', { token }, { root: true })
			token = config.MOCK && !rootState.cart.basketToken ? 'fake-token' : rootState.cart.basketToken;
			var cart = await service.checkoutSummary({token, channel: rootState.cart.basketChannel, accumulatorGroup})
			commit('setData', {item: cart})
			dispatch('cart/readCart', { cart }, { root: true})

		},
		async addressChange({state, dispatch, commit, rootState}, {shippingAddress, billingAddress}) {
			await service.checkoutAddressChange({token: rootState.cart.basketToken, data: {
				shippingAddress,
				billingAddress
			}, channel: rootState.cart.basketChannel, accumulatorGroup: "orderSubmit"})
		},
		async payments({state, dispatch, commit, rootState}, { accumulatorGroup = null } = {}) {
			let paymentsMap = await service.checkoutPayments({token: rootState.cart.basketToken, channel: rootState.cart.basketChannel, accumulatorGroup})
			//HACK: fix serverside problem
			if(paymentsMap instanceof Array) {
				paymentsMap = { "payments": [] }
			}

			//HACK: we use only the first payment
			let payments = paymentsMap.payments.length
				? Object.values(paymentsMap.payments[0].methods)
				: []

			commit('setPayments', {item: payments})
			return payments
		},
		async setPayment({state, dispatch, rootState}, {method}) {
			await service.checkoutPaymentChange({token: rootState.cart.basketToken, method, channel: rootState.cart.basketChannel, accumulatorGroup: "orderSubmit"})
		},
		async shipping({state, dispatch, commit, rootState}) {
			let shipping = await service.checkoutShipping({token: rootState.cart.basketToken, channel: rootState.cart.basketChannel})
			commit('setShippings', shipping)
			return shipping
		},
		async setShipping({state, dispatch, rootState}, {method}) {
			await service.checkoutShippingChange({token: rootState.cart.basketToken, method, channel: rootState.cart.basketChannel, accumulatorGroup: "orderSubmit" })
		},
		async submit({state, dispatch, rootState, commit}, { email, notes, orderNow, deliverTime, tip = 0, compensateCo2 = false, useDishes = false, dishReturnMethod = null, confirmedAlcohol = false, dropoffType, subscribedToNewsletter = false, acceptTerms = false, acceptPrivacy = false, userToken = null}) {
			await service.checkoutSubmit({ token: rootState.cart.basketToken, email, notes, orderNow, deliverTime, dropoffType, useDishes, dishReturnMethod, channel: rootState.cart.basketChannel, confirmedAlcohol, tip, tipOption: rootState.cart.tipOption, tipMainVariant: rootState.cart.tipMainVariant, tipSubVariant: rootState.cart.tipSubVariant, userToken, compensateCo2, subscribedToNewsletter, acceptTerms, acceptPrivacy, accumulatorGroup: "orderSubmit" })
			commit('setCheckoutToken', {item: rootState.cart.basketToken})
		},
		async order({state, dispatch, commit, rootState}) {
			let order = await service.orderShow({ token: state.checkoutToken, channel: rootState.cart.basketChannel, accumulatorGroup: "orderSubmit" })
			commit('setData', {item: order})
			return order
		},

		async savedPayments({ state, commit, rootState }, {accumulatorGroup = null} = {}) {
			let payments = await service.savedPayments({ token: rootState.cart.basketToken, accumulatorGroup })
			commit('setSavedPayments', {item: payments})
			return payments
		},

		async deleteSavedPayment({ state, commit }, { token, accumulatorGroup = null} = {}) {
			let payments = await service.deleteSavedPayment({ token, accumulatorGroup })
			commit('setSavedPayments', {item: payments})
			return payments
		},

		async transaction({commit}, { failedUrl, successUrl, token, id, paymentToken, accumulatorGroup = null} = {}) {
			let response = await service.paymentTransaction({ failedUrl, successUrl, token, id, paymentToken, accumulatorGroup });
			commit('setTransaction', {item: response});
			return response;
		},

		async escalateTimeout({ rootState }, {message, accumulatorGroup = null} = {}) {
			try {
				await service.alert({ alertType: 'payment_timeout', alertKey: rootState.cart.basketToken, alertMessage: message, accumulatorGroup })
			}
			catch {}
		}
	},
	getters: {
		checkoutState(state, getters, rootState) {
			return rootState.cart.serverData
				? rootState.cart.serverData.checkoutState
				: "none"
		},
		checkoutPayments(state) {
			return state.payments
				.map(payment => ({
					...payment,
					displayTip: !config.CHECKOUT_TIP_EXCLUDE_IDS.includes(payment.code),
					displayInvoiceAddress: config.CHECKOUT_INVOICEADDRESS_ALLOWED_IDS.includes(payment.code),
					offline: config.CHECKOUT_OFFLINEPAYMENT_IDS.includes(payment.code)
				}))
		},
		checkoutShippings(state) {
			return state.shippings
		},
		checkoutFormData(state, getters, rootState) {
			return rootState.cart.serverData
				? {
					shippingAddress: rootState.cart.serverData.shippingAddress,
					billingAddress: rootState.cart.serverData.billingAddress,
					billingAddressIdentical: rootState.cart.serverData.billingAddressIdentical,
					email: rootState.cart.serverData.email,
					deliverNow: rootState.cart.serverData.deliverNow,
					deliverTime: rootState.cart.serverData.deliverTime,
					notes: rootState.cart.serverData.notes,
					dropoffType: rootState.cart.serverData.dropoffType,
					paymentCode: rootState.cart.serverData.payments.length
						? rootState.cart.serverData.payments[0].method.code
						: "",
					compensateCo2: rootState.cart.serverData.compensateCo2,
					tip: rootState.cart.serverData.totals.tip,
					useDishes: rootState.cart.serverData.useDishes,
					// dishReturnMethod: rootState.cart.serverData.dishReturnMethod,
				}
				: null
		},
		checkoutBasketZip(state, getters, rootState) {
			if (!rootState.cart.serverData) {
				return null
			}
			return rootState.cart.serverData.zip
				? rootState.cart.serverData.zip.zip
				: null
		},
		checkoutDishReturnMethods(state, getters, rootState) {
			return [
				{ id: 'bringin', requireAddress: false, icon: 'store' },
				{ id: 'courier', requireAddress: true, icon: 'date', shippingMethods: ['delivery'] },
				{ id: 'reorder', requireAddress: false, icon: 'deliveryman', shippingMethods: ['delivery'] },
			]
		},
		checkoutTransaction(state) {
			return state.transaction;
		},
		savedPayments(state) {
			return state.savedPayments || []
		},
		checkoutMessages(state, getters, rootState) {
			return rootState.cart?.serverData?.channel?.location?.checkoutMessages || []
		},
	},
	mutations: {
		setCheckoutToken: generateSetChild("checkoutToken"),
		setData: generateSetChild("serverData"),
		setPayments: generateSetChild("payments"),
		setShippings: generateSetChild("shippings"),
		setOrderDate: generateSetChild("orderDate"),
		setTransaction: generateSetChild("transaction"),
		setSavedPayments: generateSetChild("savedPayments"),
	}
}
